export default {
  lang: 'it',
  dir: 'ltr',
  common: {
    ok: 'Salva',
    cancel: 'Annulla',
    key_backspace: 'backspace',
    key_del: 'Canc',
    key_down: 'giù',
    key_up: 'su',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: 'Mostra/nascondi strumenti per il tratto',
    palette_info: 'Fare clic per cambiare il colore di riempimento, shift-click per cambiare colore del tratto',
    zoom_level: 'Cambia il livello di zoom',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: "Identifica l'elemento",
    fill_color: 'Cambia il colore di riempimento',
    stroke_color: 'Cambia il colore del tratto',
    stroke_style: 'Cambia lo stile del tratto',
    stroke_width: 'Cambia la larghezza del tratto',
    pos_x: 'Modifica la coordinata x',
    pos_y: 'Modifica la coordinata y',
    linecap_butt: 'Inizio linea: Punto',
    linecap_round: 'Inizio linea: Tondo',
    linecap_square: 'Inizio linea: Quadrato',
    linejoin_bevel: 'Giunzione: smussata',
    linejoin_miter: 'Giunzione: spezzata',
    linejoin_round: 'Giunzione: arrotondata',
    angle: "Cambia l'angolo di rotazione",
    blur: "Cambia l'intensità della sfocatura",
    opacity: "Cambia l'opacità dell'oggetto selezionato",
    circle_cx: 'Cambia la coordinata Cx del cerchio',
    circle_cy: 'Cambia la coordinata Cy del cerchio',
    circle_r: 'Cambia il raggio del cerchio',
    ellipse_cx: "Cambia la coordinata Cx dell'ellisse",
    ellipse_cy: "Cambia la coordinata Cy dell'ellisse",
    ellipse_rx: "Cambia l'asse x dell'ellisse",
    ellipse_ry: "Cambia l'asse y dell'ellisse",
    line_x1: 'Modifica la coordinata iniziale x della linea',
    line_x2: 'Modifica la coordinata finale x della linea',
    line_y1: 'Modifica la coordinata iniziale y della linea',
    line_y2: 'Modifica la coordinata finale y della linea',
    rect_height: "Cambia l'altezza rettangolo",
    rect_width: 'Cambia la larghezza rettangolo',
    corner_radius: "Cambia il raggio dell'angolo",
    image_width: "Cambia la larghezza dell'immagine",
    image_height: "Cambia l'altezza dell'immagine",
    image_url: 'Cambia URL',
    node_x: 'Modifica la coordinata x del nodo',
    node_y: 'Modifica la coordinata y del nodo',
    seg_type: 'Cambia il tipo di segmento',
    straight_segments: 'Linea retta',
    curve_segments: 'Curva',
    text_contents: 'Cambia il contenuto del testo',
    font_family_label: 'Font:',
    font_family: 'Cambia il tipo di Font',
    font_size: 'Modifica dimensione carattere',
    bold: 'Grassetto',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Corsivo',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Menù principale',
    bkgnd_color_opac: 'Cambia colore/opacità dello sfondo',
    connector_no_arrow: 'No freccia',
    fitToContent: 'Adatta al contenuto',
    fit_to_all: 'Adatta a tutti i contenuti',
    fit_to_canvas: "Adatta all'area di disegno",
    fit_to_layer_content: 'Adatta al contenuto del livello',
    fit_to_sel: 'Adatta alla selezione',
    align_relative_to: 'Allineati a ...',
    relativeTo: 'Rispetto a:',
    page: 'Pagina',
    largest_object: 'Oggetto più grande',
    selected_objects: 'Oggetti selezionati',
    smallest_object: 'Oggetto più piccolo',
    new_doc: 'Nuova immagine',
    open_doc: 'Apri immagine',
    export_img: 'Export',
    save_doc: 'Salva',
    import_doc: 'Importa SVG',
    align_to_page: 'Allinea elementi alla pagina',
    align_bottom: 'Allinea in basso',
    align_center: 'Allinea al centro',
    align_left: 'Allinea a sinistra',
    align_middle: 'Allinea al centro',
    align_right: 'Allinea a destra',
    align_top: 'Allinea in alto',
    mode_select: 'Seleziona',
    mode_fhpath: 'Matita',
    mode_line: 'Linea',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'Rettangolo a mano libera',
    mode_ellipse: 'Ellisse',
    mode_circle: 'Cerchio',
    mode_fhellipse: 'Ellisse a mano libera',
    mode_path: 'Spezzata',
    mode_text: 'Testo',
    mode_image: 'Immagine',
    mode_zoom: 'Zoom',
    no_embed: "NOTA: L'immagine non può essere incorporata: dipenderà dal percorso assoluto per essere vista",
    undo: 'Annulla',
    redo: 'Rifai',
    tool_source: 'Modifica sorgente',
    wireframe_mode: 'Contorno',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'Raggruppa elementi',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Converti in tracciato',
    reorient_path: 'Riallinea',
    ungroup: 'Separa gli elementi',
    docprops: 'Proprietà del documento',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Sposta in fondo',
    move_top: 'Sposta in cima',
    node_clone: 'Clona nodo',
    node_delete: 'Elimina nodo',
    node_link: 'Collegamento tra punti di controllo',
    add_subpath: 'Aggiungi sotto-percorso',
    openclose_path: 'Apri/chiudi spezzata',
    source_save: 'Salva',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Livello',
    layers: 'Layers',
    del: 'Elimina il livello',
    move_down: 'Sposta indietro il livello',
    new: 'Nuovo livello',
    rename: 'Rinomina il livello',
    move_up: 'Sposta avanti il livello',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'Sposta verso:',
    move_selected: 'Sposta gli elementi in un diverso livello'
  },
  config: {
    image_props: 'Proprietà Immagine',
    doc_title: 'Titolo',
    doc_dims: "Dimensioni dell'area di disegno",
    included_images: 'Immagini incluse',
    image_opt_embed: 'Incorpora dati (file locali)',
    image_opt_ref: "Usa l'identificativo di riferimento",
    editor_prefs: 'Preferenze',
    language: 'Lingua',
    background: "Sfondo dell'editor",
    editor_img_url: 'Image URL',
    editor_bg_note: "Nota: Lo sfondo non verrà salvato con l'immagine.",
    select_predefined: 'Selezioni predefinite:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Valore assegnato non valido',
    noContentToFitTo: "Non c'è contenuto cui adeguarsi",
    dupeLayerName: "C'è già un livello con questo nome!",
    enterUniqueLayerName: 'Assegna un diverso nome a ciascun livello, grazie!',
    enterNewLayerName: 'Assegna un nome al livello',
    layerHasThatName: 'Un livello ha già questo nome',
    QmoveElemsToLayer: "Sposta gli elementi selezionali al livello '%s'?",
    QwantToClear: 'Vuoi cancellare il disegno?\nVerrà eliminato anche lo storico delle modifiche!',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'Ci sono errori nel codice sorgente SVG.\nRitorno al codice originale?',
    QignoreSourceChanges: 'Ignoro i cambiamenti nel sorgente SVG?',
    featNotSupported: 'Caratteristica non supportata',
    enterNewImgURL: "Scrivi un nuovo URL per l'immagine",
    defsFailOnSave: "NOTA: A causa dlle caratteristiche del tuo browser, l'immagine potrà apparire errata (senza elementi o gradazioni) finché non sarà salvata.",
    loadingImage: "Sto caricando l'immagine. attendere prego...",
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Nota le seguenti particolarità: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
